import React, { useState } from 'react';

import { makeStyles } from '@material-ui/styles';

import Split from 'react-split'
import { useMediaQuery, useTheme } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  screen: {
    height: 'calc(100vh - 64px)',
    overflow: 'auto',
    display: 'flex',
  },
  leftSide: {
    // flexShrink: 0,
  },
  denseScreen: {
    height: 'calc(100vh - 131px)',
  },
  gutter: {
    backgroundColor: '#FAFAFA',
    borderRight: '1px solid ' + theme.palette.neutral.light1,
    borderLeft: '1px solid ' + theme.palette.neutral.light1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  bars: {
    color: theme.palette.neutral.dark1,
    fontSize: '13px',
    fontWeight: 700,
    padding: '20px ',
  },
  open: {
    display: 'flex',
  },
  closed: {
    display: 'flex',
    '& .gutter' : {
      pointerEvents: 'none',
    },
    '& .fa-bars, & .gutter-collapse-btn': {
      opacity: .5
    },
    '& .gutter-expand-btn' : {
      pointerEvents: 'auto'
    }
  }
}))

export const SplitScreen = React.memo(({rightSide,leftSide, ...props}) => {
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  const [open, setOpen] = useState(true);

  const classes = useStyles();

  const onCollapseButtonClick = (e) => {
    setOpen(false)
  }

  const onExpandButtonClick = () => {
    setOpen(true)
    onDragEnd()
  }

  const onDragEnd = () => {
    window.dispatchEvent(new Event('splitDragEnd'))
  }

  const makeGutter = (index, direction) => {
    const gutter = document.createElement('div')
    gutter.className = `gutter gutter-${direction} ${classes.gutter}`
    gutter.innerHTML = `<i class="fas fa-bars ${classes.bars}"></i>`

    const collapseButton = document.createElement('button')
    collapseButton.setAttribute('aria-label', 'Collapse')
    collapseButton.className = 'gutter-collapse-btn'
    collapseButton.innerHTML = '<i class="fas fa-caret-left"></i>'
    collapseButton.addEventListener('click', onCollapseButtonClick)

    const expandButton = document.createElement('button')
    expandButton.setAttribute('aria-label', 'Expand')
    expandButton.className = 'gutter-expand-btn'
    expandButton.innerHTML = '<i class="fas fa-caret-right"></i>'
    expandButton.addEventListener('click', onExpandButtonClick)
    
    gutter.prepend(collapseButton)
    gutter.appendChild(expandButton)
    return gutter
  }

  
  return (
    <Split
      className={open ? classes.open : classes.closed}
      sizes={[25, 75]}
      minSize={[lg && open ? 505 : open ? 270 : 0]}
      expandToMin={true}
      gutter={makeGutter}
      gutterSize={20}
      gutterAlign="center"
      snapOffset={0}
      dragInterval={1}
      direction="horizontal"
      cursor="col-resize"
      collapsed={open ? null : 0}
      onDragEnd={onDragEnd}
    >
      <div className={`${classes.screen} ${classes.leftSide} ${props.dense ? classes.denseScreen : ''}`}>
        {leftSide}
      </div>
      
      <div className={`${classes.screen} ${props.dense ? classes.denseScreen : ''}`} style={{ backgroundColor: '#E4EAEF'}}>
        {rightSide}
      </div>
      
    </Split>
  )
})
